import React from "react";
import { Menu, Nav } from "../../../shared/components/ui/menu/Menu";
import { useSelector } from "react-redux";
import { hasBgtRoute, hasRealisticIsraelRoute } from "../../utils/utils-access-routes";
import pathRouts from "../../../shared/enums/pathRoute";
import iconsList from "../../../shared/components/ui/icons/iconsList";
import OldViewBtn from "../../../shared/components/ui/oldViewBtn/OldViewBtn";

const LeftSideMenu = ({ dynamicTabs, className, forceCompact = false }) => {

    const { texts } = useSelector(state => state.translate);
    const { isStudent, user, isAuth } = useSelector(state => state.auth);
    const { general } = useSelector(state => state.uiData);

    return (
        <Menu canClosed={true} overlayBreakpoint={1030} className={className} forceCompact={forceCompact}>
            <Nav title={texts.homePage} icon={iconsList.home} to={`/${pathRouts.HOME}`} />
            <Nav title={texts.calendar} icon={iconsList.calendar} to={`/${pathRouts.CALENDAR}`}/>
            <Nav title={texts.myLearning} icon={iconsList.myLearning} to={`/${pathRouts.MYLEARNING}`} />
            <Nav title={texts.usefulTools} icon={iconsList.usefulTools} to={`/${pathRouts.USEFULTOOLS}`} />
            <Nav title={texts.discovery} icon={iconsList.discovery} to={`/${pathRouts.DISCOVERY}`} />
            <Nav title={texts.plusLearning} icon={iconsList.plusLearning} to={`/${pathRouts.PLUSLEARNING}`} />
            {dynamicTabs?.map(tab =>
                <Nav
                    key={tab.key}
                    title={texts[tab.titleKey]}
                    icon={tab.icon}
                    to={tab.route}
                />
            )}
        </Menu>
    );
};

export default LeftSideMenu;